<template>
  <div>
    <div class="fixed-bottom bg-white rounded-top-lg shadow-lg p-4" style="z-index:2000;">
      <h3 class="text-center">調整字級大小</h3>
      <div class="d-flex justify-content-around mt-4">
        <a href="#" @click.prevent="changeFontSize('1rem')"
          class="font-size-change-btn" style="font-size: 1rem"
          :class="{'bg-light text-primary': fontSize == '1rem'}">小</a>
        <a href="#" @click.prevent="changeFontSize('1.25rem')"
          class="font-size-change-btn" style="font-size: 1.25rem"
          :class="{'bg-light text-primary': fontSize == '1.25rem'}">中</a>
        <a href="#" @click.prevent="changeFontSize('1.5rem')"
          class="font-size-change-btn" style="font-size: 1.5rem"
          :class="{'bg-light text-primary': fontSize == '1.5rem'}">大</a>
      </div>
    </div>
    <div class="modal-backdrop" @click="closeModal"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fontSize: '1rem',
    };
  },
  methods: {
    closeModal() {
      this.$bus.$emit('changeFontModalShow', false);
    },
    changeFontSize(size) {
      this.fontSize = size;
      this.$bus.$emit('changeFontSize', size);
      window.localStorage.setItem('biz_fontSize', size);
    },
  },
  mounted() {
    this.fontSize = window.localStorage.getItem('biz_fontSize') || '1rem';
    this.$bus.$emit('changeFontSize', this.fontSize);
  },
};
</script>

<style lang="scss" scoped>
.rounded-top-lg {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.font-size-change-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  text-decoration: none;
}
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.35);
  height: 100%;
}
</style>
